import axios from 'axios';

// Centralized axios instance so every API call shares the same base URL and headers.
// This means we only configure things like the base URL or auth token ONCE here,
// instead of repeating it in every single API call across the app.
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    // Without this, ngrok's free-tier interstitial warning page intercepts
    // EVERY request that hasn't been manually "clicked through" in a real
    // browser tab first — which is why login worked (visited once, manually)
    // but every other API call, only ever made via axios, kept failing with
    // what looked like a CORS error but was actually ngrok's HTML warning
    // page being returned instead of real JSON. This header tells ngrok to
    // skip that page entirely, for every request, permanently.
    'ngrok-skip-browser-warning': 'true',
  },
});

// Automatically attach the JWT token (if it exists) to every outgoing request.
// This runs before every request is sent.
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosInstance;